import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { Router } from '@angular/router';

export interface movies{
  bannerUrl:any;
  description:any;
  id:any;
  name:any;
  totalUpvotes:any;
  totalViews:any;
};
export interface titles{
  bannerImage:any;
  description:any;
  movies:movies[];
  title:any;
};


@Component({
  selector: 'app-hitmaker-main-page',
  templateUrl: './hitmaker-main-page.component.html',
  styleUrls: ['./hitmaker-main-page.component.css']
})
export class HitmakerMainPageComponent implements OnInit {
  movie1: movies;
  movie2: movies;
  movie3: movies;
  firstMovieImg: any;
  secondMovieImg: any;
  firstMovieName: any;
  thirdMovieImg: any;
  secondMovieName: any;
  thirdMovieName: any;
  firstMovieId: any;
  secondMovieId: any;
  thirdMovieId: any;
  moviesList:movies[]=[];
 
  mainDesc: any;
  mainTitle: any;
  mainBannerImg: any;
  userId: any;
  constructor( private adminApi: AdminService, private router: Router) { }
  titles:titles;
  
  ngOnInit(): void {
    this.adminApi.getCreaticsHomepage().subscribe(data => {
      this.userId = data.userId;
    })
    this.adminApi.getHitmakerMain().subscribe(data =>{
      this.titles =data as titles;
      this.mainDesc=this.titles.description;
      this.mainTitle=this.titles.title;
      this.mainBannerImg=this.titles.bannerImage;
      this.moviesList=this.titles.movies.reverse();
    });
  }

  getMovieDetails(movie:movies){
    this.router.navigate(['/hitmaker/' + movie.id]);
  }   

}
